$(document).ready(function() {
  
  // Menu items helemaal klikbaar
  $('li.block').click(function(){
    var url = $('a:first',this).attr('href');
    if (url!=='') location = url;
  });  

  $('.block:not(.big):not(.active)').animateItems();

  // Start situatie
  $('.block.big .hide-onload').hide();
  $('.block.big').css('height','160');

});

function getRandomInt(max) {
  return Math.floor(Math.random() * Math.floor(max));
}

$(window).load(function() {
  // Situatie na laden
  $('.block.big').each(function(){
    var bigHeight = $(this).height();
    var innerHeight = 0;
    $('.inner',this).each(function(){
      innerHeight += $(this).height() + 20;
    });
    $('.carousel',this).each(function(){
      innerHeight += $(this).width() + 20; // same as height
    });
    if (innerHeight>bigHeight) {
      var itemHeight = $('.block:not(.big):first').height();
      var itemMargin = $('.block:not(.big):first').css('margin-bottom').replace('px','');
      var add = Number(itemHeight) + Number(itemMargin) + 2;
      while (innerHeight>bigHeight) {
        bigHeight += add;
      }
      bigHeight += 2;
      //
      $('.block.big .hide-onload').show();
      $(this).animate({'height':bigHeight});
    }
  });
});

$(window).resize(function() {
});

//
// Minimal jQuery plugin template, for more comments see template.js (which has essentially the same template as the one here)
//
(function($) {
  var defaults = {
    start       : 10000,
    maxMovement : 38,
    button      : '.pause-button',
    playing     : false,
  };
  var opts;
  var self;
  var items = [];
  var methods = {
    init : function( options ) {
      self = this;
   		opts = $.extend({}, defaults, options);

      opts.pause = $(opts.button);

      // Init items
      self.each(function(){
        var elm = this;
        var id = $(this).attr('id'); 
        var item = {
          elm     : elm,
          id      : id,
          oeps    : 'oeps!',
          x       : 0,
          y       : 0,
          center  : {},
          size    : $(elm).width(),
          max     : 0,
          timer   : {},
          start   : function() {
            var obj = this;
            this.timer = window.setInterval(function(){
              if (opts.playing) {
                obj.max += 1;
                if (obj.max > opts.maxMovement) obj.max = opts.maxMovement;
                obj.x = methods.random(-obj.max,obj.max);
                obj.y = methods.random(-obj.max,obj.max);
                $(obj.elm).animate({'left': (obj.x+'px'),'top': (obj.y+'px')},methods.random(500,1000),'swing',function(){
                  var position = $(obj.elm).position();
                  obj.center = {
                    left : position.left + obj.size / 2,
                    top  : position.top + obj.size / 2,
                  };
                  // Detect collision
                  // methods.detectCollisions(obj);
                });
              }
            }, methods.random(1100,2000) );
            // bind pause
            $(obj.elm).on('mouseover',function(){
              obj.pause();
            });
          },
          pause   : function() {
            var obj = this;
            obj.max = 0;
            $(obj.elm).stop();
            window.clearInterval(obj.timer);
            $(obj.elm).unbind('mouseover');
            $(obj.elm).on('mouseleave',function(){
              obj.start();
              $(obj.elm).unbind('mouseleave');
            });
          },
          collision : function() {
            var obj = this;
            $(obj.elm).addClass('collided');//.append('<span class="oeps">'+obj.oeps+'</span>');
            window.setTimeout(function(){
              $(obj.elm).removeClass('collided');
              // $('.oeps',obj.elm).remove();
            },100);
          }
        };
        items.push(item);
      });

      // Start
      $(opts.pause).click(function(){
        opts.playing = !opts.playing;
        methods.playbuttonStatus();
      });
      methods.startAnimations();
      window.setTimeout(function(){
        opts.playing = true;
        methods.playbuttonStatus();
      }, opts.start );

      return self;
    },

    startAnimations : function() {
      for (var i = items.length - 1; i >= 0; i--) {
        items[i].start();
      }
    },

    playbuttonStatus : function() {
      if (opts.playing) {
        $('.action-pause',opts.pause).removeClass('hidden');
        $('.action-play',opts.pause).addClass('hidden');
      }
      else {
        $('.action-pause',opts.pause).addClass('hidden');
        $('.action-play',opts.pause).removeClass('hidden');
      }
    },

    detectCollisions : function(item) {
      var collided = false;
      var size = item.size + 2;
      for (var i = items.length - 1; i >= 0; i--) {
        if (items[i].id !==item.id) {
          if ( Math.abs(item.center.left-items[i].center.left) < size && Math.abs(item.center.top-items[i].center.top) < size ) {
            collided = true;
            item.collision();
            items[i].collision();
          }
        }
      }
      return collided;
    },

    random : function(min,max) {
      return min + Math.floor(Math.random() * Math.floor(max-min));
    },
  };
  $.fn.animateItems = function(methodOrOptions) {
     if ( methods[methodOrOptions] ) {
       return methods[ methodOrOptions ].apply( this, Array.prototype.slice.call( arguments, 1 ));
     } else if ( typeof methodOrOptions === 'object' || ! methodOrOptions ) {
       return methods.init.apply( this, arguments );
     } else {
       $.error( 'Method "' +  methodOrOptions + '" does not exist on jQuery.animateItems' );
     }    
   };  
})(jQuery);






